module.exports = __webpack_public_path__ + "img/article6.df4817cf.jpeg";